export const OMNITRACKER_URL =
  'https://smswgp.konzern.ewe.info/otwg/Login.aspx?lang=de&guestlogin=1';
